import React from "react";

export const SectionHead = ({
  eyebrow,
  title,
  action,
}: {
  eyebrow: string;
  title: string;
  action?: React.ReactNode;
}) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
    <div>
      <div className="flex items-center gap-3">
        <span className="h-[2px] w-10 bg-neon pc-glow" />
        <span className="text-[11px] font-bold uppercase tracking-[0.28em] text-neon">{eyebrow}</span>
      </div>
      <h2 className="mt-3 font-bebas text-4xl sm:text-5xl tracking-wide uppercase">{title}</h2>
    </div>
    {action}
  </div>
);

export const Pill = ({ children, tone = "neutral" }: { children: React.ReactNode; tone?: string }) => {
  const tones: Record<string, string> = {
    neutral: "border-white/15 text-white/60",
    neon: "border-neon/50 text-neon",
    blue: "border-pcblue/60 text-pcblue",
    yellow: "border-pcyellow/60 text-pcyellow",
  };
  return (
    <span className={`inline-block border px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.18em] ${tones[tone]}`}>
      {children}
    </span>
  );
};

export const Progress = ({ value, goal }: { value: number; goal: number }) => {
  const pct = Math.min(100, goal ? (value / goal) * 100 : 0);
  return (
    <div className="h-1.5 w-full bg-white/10 overflow-hidden">
      <div
        className="h-full bg-neon transition-[width] duration-700"
        style={{ width: `${pct}%`, boxShadow: "0 0 10px #FF003C" }}
      />
    </div>
  );
};

export const Loader = () => (
  <div className="py-24 grid place-items-center" data-testid="loader">
    <div className="h-8 w-8 border-2 border-neon border-t-transparent rounded-full animate-spin" />
  </div>
);

export const Empty = ({ text, testid }: { text: string; testid?: string }) => (
  <div className="border border-dashed border-white/12 py-16 text-center text-sm text-white/40" data-testid={testid}>
    {text}
  </div>
);
